'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactBootstrap = require('react-bootstrap');

var _reactSelect = require('react-select');

require('react-select/dist/react-select.css');

require('./AddressInputView.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AddressInputView: {
        displayName: 'AddressInputView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/AddressInput/default/AddressInputView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AddressInputView = _wrapComponent('AddressInputView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(AddressInputView, _Component);

    function AddressInputView(props) {
        (0, _classCallCheck3.default)(this, AddressInputView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddressInputView.__proto__ || (0, _getPrototypeOf2.default)(AddressInputView)).call(this, props));

        _this.sortAddresses = function (addresses) {
            var defaultIdx = addresses.findIndex(function (address) {
                return address.is_default;
            });
            if (defaultIdx < 0) return addresses.sort(function (a, b) {
                return b.id - a.id;
            });
            var defaultAddress = (0, _extends3.default)({}, addresses[defaultIdx]);
            addresses.splice(defaultIdx, 1);
            addresses.sort(function (a, b) {
                return b.id - a.id;
            });
            addresses.unshift(defaultAddress);
            return addresses;
        };

        _this.state = {
            isSelectOpen: false
        };

        _this.handleClickOutside = _this.handleClickOutside.bind(_this);

        if (!(typeof _this.handleClickOutside === 'function')) {
            throw new TypeError('Value of "this.handleClickOutside" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.handleClickOutside));
        }

        return _this;
    }

    (0, _createClass3.default)(AddressInputView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }

        /**
         * Alert if clicked on outside of element
         */

    }, {
        key: 'handleClickOutside',
        value: function handleClickOutside(event) {
            var select = document.getElementById('address-select');
            if (select && !select.contains(event.target)) {
                this.setState({ isSelectOpen: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                placeholder = _props.placeholder,
                value = _props.value,
                options = _props.options,
                label = _props.label,
                buttonText = _props.buttonText,
                buttonAddAddressText = _props.buttonAddAddressText,
                noOptionsMessageText = _props.noOptionsMessageText,
                onAddressChange = _props.onAddressChange,
                onButtonClick = _props.onButtonClick,
                onAddAddress = _props.onAddAddress,
                isOrderWasPaid = _props.isOrderWasPaid;

            /** Если оставить по дефолту, то клавиша "," создает новую опцию */

            var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(keyCode) {
                return [9, // tab
                13].indexOf(keyCode) !== -1;
            };

            var isAddButtonDisabled = !value.address || !!options.find(function (option) {
                return option.address === (value || {}).address && typeof option.id === 'number';
            });
            var isSelectOpen = this.state.isSelectOpen;


            return _react3.default.createElement(
                'div',
                { className: 'address-select__container' },
                _react3.default.createElement(
                    _reactBootstrap.FormGroup,
                    { className: 'address-select__from-group col-xs-12 col-sm-6' },
                    _react3.default.createElement(
                        _reactBootstrap.ControlLabel,
                        null,
                        label
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'address-select__input-select' },
                        _react3.default.createElement(
                            'svg',
                            { onClick: function onClick() {
                                    return onAddressChange({ address: null });
                                }, id: 'Capa_1', className: 'clear', 'enable-background': 'new 0 0 386.667 386.667', height: '10px', viewBox: '0 0 386.667 386.667', width: '10px', xmlns: 'http://www.w3.org/2000/svg' },
                            _react3.default.createElement('path', { d: 'm386.667 45.564-45.564-45.564-147.77 147.769-147.769-147.769-45.564 45.564 147.769 147.769-147.769 147.77 45.564 45.564 147.769-147.769 147.769 147.769 45.564-45.564-147.768-147.77z' })
                        ),
                        _react3.default.createElement('input', {
                            onChange: function onChange(e) {
                                return onAddressChange({ address: e.target.value });
                            },
                            value: value.address,
                            onFocus: function onFocus() {
                                return _this2.setState({ isSelectOpen: true });
                            },
                            placeholder: placeholder,
                            className: 'form-control',
                            type: 'text',
                            list: 'list'
                        }),
                        isSelectOpen && _react3.default.createElement(
                            'ul',
                            { id: 'address-select' },
                            this.sortAddresses(options).map(function (option) {
                                return _react3.default.createElement(
                                    'li',
                                    { onClick: function onClick(e) {
                                            onAddressChange({ address: e.target.innerText });
                                            _this2.setState({ isSelectOpen: false });
                                        } },
                                    option.address
                                );
                            })
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-3 col-xs-12 text-right' },
                    _react3.default.createElement(
                        'button',
                        {
                            disabled: isOrderWasPaid,
                            onClick: onButtonClick,
                            className: 'le-button pay_order_button button_width_100 ' + (isOrderWasPaid ? 'disabled' : '')
                        },
                        buttonText
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-3 text-center' },
                    _react3.default.createElement(
                        'button',
                        {
                            disabled: isAddButtonDisabled,
                            onClick: function onClick() {
                                return onAddAddress({ address: (value || {}).address });
                            },
                            className: 'le-button pay_order_button button_width_100}'
                        },
                        buttonAddAddressText
                    )
                )
            );
        }
    }]);
    return AddressInputView;
}(_react2.Component), _class.propTypes = {
    isOrderWasPaid: _react2.PropTypes.bool,
    placeholder: _react2.PropTypes.string.isRequired,
    value: _react2.PropTypes.object.isRequired,
    options: _react2.PropTypes.array.isRequired,
    label: _react2.PropTypes.string.isRequired,
    buttonText: _react2.PropTypes.string.isRequired,
    buttonAddAddressText: _react2.PropTypes.string.isRequired,
    noOptionsMessageText: _react2.PropTypes.string.isRequired,
    buttonSaveText: _react2.PropTypes.string.isRequired,
    onAddressChange: _react2.PropTypes.func.isRequired,
    onAddressSave: _react2.PropTypes.func,
    onButtonClick: _react2.PropTypes.func.isRequired,
    onAddAddress: _react2.PropTypes.func.isRequired,
    disableAddNewAddress: _react2.PropTypes.bool
}, _temp));

exports.default = AddressInputView;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddressInput/default/AddressInputView.jsx
// module id = 1596
// module chunks = 0